module.exports = __webpack_public_path__ + "acaeff5a2270adf90cf39029b31378a4.jpg";